<h1 mat-dialog-title>
  @if (Invoice()) {
    <span class="main-title">
      Edit Invoice {{Invoice().InvoiceNumber}} -
    </span>
    @if (!isFromVendor) {
      <a class="vendor-link" (click)="editVendor(Invoice().VendorId)">{{Invoice().VendorName}} ({{Invoice().VendorCode}}) </a>
    }
    @if (isFromVendor) {
      <span class="main-title"> {{Invoice().VendorName}} ({{Invoice().VendorCode}})</span>
    }
    <span class="sub-title">
      @if (isPurchaseOrderInvoice()) {
        Purchase Order: {{Invoice().PurchaseOrderNumber}}
      }
      @if (isPurchaseRequestInvoice()) {
        Purchase Request: {{Invoice().PurchaseRequisitionNumber}}
      }
    </span>
  }
</h1>

<div mat-dialog-content #modalContainer scrollInsetShadow>
  <form name="invoice-edit-form" #invoiceEditForm="ngForm" style="padding-bottom: 15px;">

    @if (Invoice()) {
      <div class="row">
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-6">
              <div class="row">
                <ng-container *ngTemplateOutlet="vendorInvoiceNumber; context: cols.sm8"></ng-container>
                <ng-container *ngTemplateOutlet="invoiceStatus; context: cols.sm4"></ng-container>
              </div>
              <div class="row">
                <ng-container *ngTemplateOutlet="vendorInvoiceDate; context: cols.sm6"></ng-container>
                <ng-container *ngTemplateOutlet="dueDate; context: cols.sm6"></ng-container>
              </div>
              <div class="row">
                <ng-container *ngTemplateOutlet="checkNumber; context: cols.sm6"></ng-container>
                <ng-container *ngTemplateOutlet="paidDate; context: cols.sm6"></ng-container>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <ng-container *ngTemplateOutlet="timeline; context: cols.sm6"></ng-container>
                <ng-container *ngTemplateOutlet="timelineAgreement; context: cols.sm6"></ng-container>
              </div>
              <div class="row">
                <ng-container *ngTemplateOutlet="poNumber; context: cols.sm6"></ng-container>
                <ng-container *ngTemplateOutlet="prNumber; context: cols.sm6"></ng-container>
              </div>
              <div class="row">
                <ng-container *ngTemplateOutlet="poEnd; context: cols.sm6"></ng-container>
                <ng-container *ngTemplateOutlet="agreementEnd; context: cols.sm6"></ng-container>
              </div>
              <div class="row">
                <ng-container *ngTemplateOutlet="paymentPlan; context: cols.sm6"></ng-container>
                <ng-container *ngTemplateOutlet="poRequired; context: cols.sm6"></ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <document-picker (safeToSaveParent)="onSafeToSaveParent($event)" [(documents)]="Invoice().Documents" [canAdd]="!isDocumentChangeDisabled() && UserIsAdmin" [canRemove]="!isDocumentChangeDisabled() && UserIsAdmin" [isAtLeastOneRequired]="false"></document-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <invoice-payment-line-item-assoc [(data)]="AssocData" [invoiceNumber]="Invoice().InvoiceNumber" [invoiceId]="Invoice().Id" [isDisabled]="isDocumentChangeDisabled() || !UserIsAdmin"></invoice-payment-line-item-assoc>
        </div>
      </div>
    }

    <ng-template #vendorInvoiceNumber let-col>
      <div [class]="col">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Vendor Invoice Number</mat-label>
          <input matInput [(ngModel)]="Invoice().VendorAssignedInvoiceNumber" name="invoiceNum" [disabled]="!isNewStatus() || !UserIsAdmin" />
        </mat-form-field>
      </div>
    </ng-template>
    <ng-template #vendorInvoiceDate let-col>
      <div [class]="col">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Vendor Invoice Date</mat-label>
          <input matInput [(ngModel)]="Invoice().VendorInvoiceDate" #vendorInvoiceDateCtl name="vendorInvoiceDate"
            [matDatepicker]="vendorInvoiceDateDatepicker" [disabled]="!isNewStatus() || !UserIsAdmin" />
            <mat-datepicker-toggle matSuffix [for]="vendorInvoiceDateDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #vendorInvoiceDateDatepicker></mat-datepicker>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-template #dueDate let-col>
        <div [class]="col">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Due Date</mat-label>
            <input matInput [(ngModel)]="Invoice().DueDate" #dueDateCtl name="dueDate"
              [matDatepicker]="dueDateDatepicker" [disabled]="!isNewStatus() || !UserIsAdmin" />
              <mat-datepicker-toggle matSuffix [for]="dueDateDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #dueDateDatepicker></mat-datepicker>
            </mat-form-field>
          </div>
        </ng-template>
        <ng-template #poNumber let-col>
          <div [class]="col">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Purchase Order</mat-label>
              <input matInput [(ngModel)]="Invoice().PurchaseOrderNumber" #po name="po" disabled />
            </mat-form-field>
          </div>
        </ng-template>
        <ng-template #prNumber let-col>
          <div [class]="col">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Purchase Request</mat-label>
              <input matInput [(ngModel)]="Invoice().PurchaseRequisitionNumber" #pr name="pr" disabled />
            </mat-form-field>
          </div>
        </ng-template>
        <ng-template #invoiceStatus let-col>
          <div [class]="col">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Status</mat-label>
              <mat-select panelClass="invoice-modal-select-panel" required [(ngModel)]="Invoice().InvoiceStatus" #quoteStatus name="InvoiceStatus" [disabled]="!UserIsAdmin">
                @for (status of Dropdowns.InvoiceStatuses; track status) {
                  <mat-option [value]="status.id" [disabled]="!status.isEnabled()">{{status.label}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </ng-template>
        <ng-template #checkNumber let-col>
          <div [class]="col">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Check Number</mat-label>
              <input matInput [(ngModel)]="Invoice().PaymentCheck" name="checkNum" [disabled]="!isComplete() || !UserIsAdmin" />
            </mat-form-field>
          </div>
        </ng-template>
        <ng-template #paidDate let-col>
          <div [class]="col">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Paid</mat-label>
              <input matInput [(ngModel)]="Invoice().PaymentDate" #paidDateCtl name="paidDate"
                [matDatepicker]="paidDateDatepicker" [disabled]="!isComplete() || !UserIsAdmin" />
                <mat-datepicker-toggle matSuffix [for]="paidDateDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #paidDateDatepicker></mat-datepicker>
              </mat-form-field>
            </div>
          </ng-template>

          <ng-template #timeline let-col>
            <div [class]="col">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Timeline (Calc)</mat-label>
                <input matInput [(ngModel)]="TimelineCalc" name="timelineCalc" disabled />
              </mat-form-field>
            </div>
          </ng-template>
          <ng-template #timelineAgreement let-col>
            <div [class]="col">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Timeline (Agreement)</mat-label>
                <input matInput [(ngModel)]="Invoice().AgreementTimeline" name="timelineAgreement" disabled />
              </mat-form-field>
            </div>
          </ng-template>
          <ng-template #paymentPlan let-col>
            <div [class]="col">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Payment Plan (Agreement)</mat-label>
                <input matInput [(ngModel)]="Invoice().AgreementPaymentPlan" name="paymentPlan" disabled />
              </mat-form-field>
            </div>
          </ng-template>
          <ng-template #poRequired let-col>
            <div [class]="col">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Purchase Order Required</mat-label>
                <input matInput [ngModel]="Invoice().VendorPurchaseOrderRequired | YesNo" name="poRequired" disabled />
              </mat-form-field>
            </div>
          </ng-template>
          <ng-template #poEnd let-col>
            <div [class]="col">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>PO End</mat-label>
                @if (Invoice().QuotePurchaseOrderEndDates?.length == 1) {
                  <input matInput name="poEnd" value="{{ PoEnd | date:'d-LLL-y' }}" disabled />
                }
                @if (Invoice().QuotePurchaseOrderEndDates?.length != 1) {
                  <input matInput name="poEnd" value="{{ PoEnd }}" disabled />
                }
              </mat-form-field>
            </div>
          </ng-template>
          <ng-template #agreementEnd let-col>
            <div [class]="col">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Active Agreement End</mat-label>
                <input matInput name="agreementEnd" value="{{ Invoice().AgreementEndDate | date:'d-LLL-y' }}" disabled />
              </mat-form-field>
            </div>
          </ng-template>
        </form>
      </div>

      <div mat-dialog-actions style="display: flex">
        @if (Invoice()) {
          <dl class="dl-horizontal modal-audit-info">
            @if (Invoice().CreatedByName != undefined && Invoice().CreatedByPersonId != 0) {
              <dt>Created:</dt>
            }
            @if (Invoice().CreatedByName != undefined && Invoice().CreatedByPersonId != 0) {
              <dd>{{ Invoice().CreatedDate | date:'d-LLL-y' }} by {{ Invoice().CreatedByName }}</dd>
            }
            @if (Invoice().UpdatedByName != undefined && Invoice().UpdatedByPersonId != 0) {
              <dt>Updated:</dt>
            }
            @if (Invoice().UpdatedByName != undefined && Invoice().UpdatedByPersonId != 0) {
              <dd>{{ Invoice().UpdatedDate | date:'d-LLL-y' }} by {{ Invoice().UpdatedByName }}</dd>
            }
          </dl>
        }

        <span style="flex: 1 1 auto;"></span>

        <button mat-raised-button color="warn" (click)="DeleteInvoice()" [disabled]="DisableDelete()">Delete</button>
        <button mat-raised-button color="accent" (click)="CancelModal()">Cancel</button>
        <button mat-raised-button color="primary" (click)="Save(invoiceEditForm)">Save</button>
        <button mat-raised-button color="primary" (click)="SaveAndClose(invoiceEditForm)">Save &amp; Close</button>
      </div>
